import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { http } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function BookingResult({ success }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(success ? "polling" : "cancelled");
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (!success || !sessionId) return;
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const { data } = await http.get(`/checkout/status/${sessionId}`);
        setDetails(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attempts >= 6) { setStatus("timeout"); return; }
        setTimeout(poll, 2000);
      } catch {
        setStatus("error");
      }
    };
    poll();
  }, [sessionId, success]);

  return (
    <div className="max-w-xl mx-auto px-6 py-20 text-center">
      <Card className="border-border/60">
        <CardContent className="p-10 space-y-4">
          {status === "polling" && <><Loader2 className="mx-auto animate-spin text-secondary" size={48} /><h1 className="font-display text-2xl font-bold text-primary">Confirming payment…</h1></>}
          {status === "paid" && <><CheckCircle2 className="mx-auto text-secondary" size={56} /><h1 className="font-display text-3xl font-bold text-primary">You're all set!</h1><p className="text-muted-foreground">Your first cleaning is scheduled. We just emailed you a receipt and the details.</p></>}
          {status === "cancelled" && <><XCircle className="mx-auto text-destructive" size={56} /><h1 className="font-display text-3xl font-bold text-primary">Payment cancelled</h1><p className="text-muted-foreground">No charge has been made. You can resume booking any time.</p></>}
          {(status === "expired" || status === "timeout" || status === "error") && <><XCircle className="mx-auto text-destructive" size={56} /><h1 className="font-display text-2xl font-bold text-primary">Could not confirm payment</h1><p className="text-muted-foreground">Please check your dashboard — your booking will appear once we receive confirmation from Stripe.</p></>}

          {details && <div className="text-xs text-muted-foreground mt-2">Stripe status: {details.status} · {details.payment_status}</div>}

          <div className="flex gap-2 justify-center pt-4">
            <Button asChild className="bg-primary hover:bg-primary/90" data-testid="result-go-dashboard"><Link to="/parent">Go to dashboard</Link></Button>
            <Button asChild variant="outline" data-testid="result-book-again"><Link to="/booking">Book another</Link></Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
